import React from 'react'
import { Text } from 'react-form'
import {Form, Col, FormGroup, Button, ControlLabel} from 'react-bootstrap'
import {Link} from 'react-router'
import {Actions} from 'jumpstate'

export default ({submitForm, resetForm}) => {
  return (
    <Form horizontal onSubmit={submitForm}>
      <FormGroup>
        <Col componentClass={ControlLabel} sm={2}>
          نام کاربری
        </Col>
        <Col sm={10}>
          <Text
            field="username"
            placeholder="نام کاربری"
            className="form-control"
            />
        </Col>
      </FormGroup>

      <FormGroup>
        <Col componentClass={ControlLabel} sm={2}>
          رمز عبور
        </Col>
        <Col sm={10}>
          <Text
            field="password"
            type="password"
            placeholder="رمز عبور"
            className="form-control"
          />
        </Col>
      </FormGroup>

      <FormGroup>
        <Col smOffset={2} sm={10}>
          <Button type="submit">
            ورود
          </Button>
          {' '}
          <Link to="/signup" onClick={() => Actions.toggleLoginBox(false)} className="btn btn-default">
            ثبت نام
          </Link>
          {' '}
        </Col>
        <Col smOffset={2} sm={10} style={{marginTop: '10px'}}>
          <Link to="/forget-password" onClick={() => Actions.toggleLoginBox(false)}>فراموشی رمز عبور</Link>
        </Col>
      </FormGroup>
    </Form>
  )
}



// WEBPACK FOOTER //
// ./src/components/Common/LoginBox/LoginForm.js